// extracted by mini-css-extract-plugin
export default {"filtersGrid":"ProjectsDashboardPage_filtersGrid__yAqpm"};